import GqlQuery from "@/plugins/gql"
import { rsort } from "semver";
export default {
    data() {
      return {
        mixin_settings: {
          name: null,
          cancel_name: null,
          email: null,
          email_verified: null
        },
        mixin_plan:'',
        mixin_charges: false,
        mixin_loading: false,
        mixin_organization_id: false,
        mixin_admin: false,
        mixin_selectPlan: null,
        mixin_customer_id: null,
        mixin_stripeLoading: null,
        isFreePlan:false,
        isMakerPlan:false,
        isTeamPlan:false,
        isCompanyPlan:false,
        showFreeBanner:false,
        showMakerBanner:false,
        showTeamBanner:false,
        showCompanyBanner:false,
        showGrandfatheredBanner: false,
        publishedTutorials: 0,
        allowPublish: false,
      }
    },
    methods: {
        checkPlanForUsers(plan, plan_status, users) {
            console.log("entering checkPlanForUsers")
            let self=this;
            console.log("plan", plan)
            console.log("plan_status", plan_status)
            console.log("users", users)
            if(plan==null || plan==""){
                self.showFreeBanner=true;
                if(users.length>=1){
                    return false;
                }
                return true;
            }else if(plan_status=="active"){
                if(plan==process.env.MAKER_MONTHLY_PLAN_ID || plan==process.env.MAKER_YEARLY_PLAN_ID){
                    console.log("showing maker banner")
                    self.showMakerBanner=true;
                    if(users.length>=1){
                        return false;
                    }else{
                        return true;
                    }
                }else if(plan==process.env.TEAM_MONTHLY_PLAN_ID || plan==process.env.TEAM_YEARLY_PLAN_ID){
                    self.showTeamBanner=true;
                    if(users.length>=10){
                        return false;
                    }else{
                        return true;
                    }
                }else if(plan==process.env.COMPANY_MONTHLY_PLAN_ID || plan==process.env.COMPANY_YEARLY_PLAN_ID){
                    self.showCompanyBanner=true;
                    if(users.length>=100){
                        return false;
                    }else{
                        return true;
                    }
                }else{
                    return true;
                }
            }else{
                return false;
            }
        },
        getCustomer() {
            console.log("entering getCustomer")
            var self = this;
            var body = JSON.stringify({ customer_id: self.customer_id });
            StripeApi.call("getCustomer", body, function(err, response) {
                self.plan = response.subscriptions.data[0];
                self.card = response.sources.data[0];
                self.stripeLoading=false;
                console.log("Setting getCUstomer to ", self.stripeLoading)
            });
        
            StripeApi.call("getCustomerHistory", body, function(err, response) {
                self.charges = response.data;
            });
        },
        async checkGrandfatheredQuizzes(quizzes){
            console.log("in checkGrandfathered")
            let self=this;
            const canProceed = await this.checkPlanForQuizzes(this.quizzes);
            console.log("canProceed", canProceed)
            if (!canProceed) {
                self.showGrandfatheredBanner=true;
            }
        },
        async checkGrandfatheredTutorials(articles){
            console.log("in checkGrandfatheredTutorials")
            let self=this;
            const canProceed = await this.checkPlanForTutorials(articles);
            console.log("canProceed", canProceed)
            if (!canProceed) {
                self.showGrandfatheredBanner=true;
            }
            
        },
        async getPlanAllowedVideoDuration() {
            return new Promise((resolve, reject) => {
                console.log("loadPlanData");
                var self = this;
                GqlQuery.getOrganization(function(err, organization) {
                    organization.then((org)=> {
                    var user_org = org.data.organizations[0];
                    //console.log("user_org", user_org)
                    if(user_org.plan==null || user_org.plan==""){
                        console.log("no plan")
                        self.showFreeBanner=true;
                        resolve(300)
                    }else{
                        if(user_org.plan==process.env.MAKER_MONTHLY_PLAN_ID || user_org.plan==process.env.MAKER_YEARLY_PLAN_ID){
                            self.showMakerBanner=true;
                            resolve(600) //10 minutes
                        }else if(user_org.plan==process.env.TEAM_MONTHLY_PLAN_ID || user_org.plan==process.env.TEAM_YEARLY_PLAN_ID){
                            self.showTeamBanner=true;
                            resolve(9600) //2 hours 40 minutes
                        }else if(user_org.plan==process.env.COMPANY_MONTHLY_PLAN_ID || user_org.plan==process.env.COMPANY_YEARLY_PLAN_ID){
                            self.showCompanyBanner=true;
                            resolve(9600) //2 hours 40 minutes
                        }
                        console.log("has plan, but resolving to 300 seconds")
                        resolve(300)
                    }
                    })
                })
            })
        },
        async checkPlanForVideoUpload() {
            return new Promise((resolve, reject) => {
                console.log("loadPlanData");
                var self = this;
                GqlQuery.getOrganization(function(err, organization) {
                    organization.then((org)=> {
                    var user_org = org.data.organizations[0];
                    //console.log("user_org", user_org)
                    if(user_org.plan==null || user_org.plan==""){
                        console.log("no plan")
                        self.showFreeBanner=true;
                        resolve(false)
                    }else{
                        console.log("has plan")
                        resolve(true)
                    }
                    })
                })
            })
        },
        async checkPlanForTutorials(articles) {
            let self=this;
            return new Promise((resolve, reject) => {
                console.log("loadPlanData");
                var self = this;
                GqlQuery.getOrganization( function(err, organization) {
                    organization.then((org)=> {
                    var user_org = org.data.organizations[0];
                    //console.log("user_org", user_org)
                    //console.log("plan", user_org.plan)
                    self.mixin_plan=user_org.plan;

                    if(user_org.plan==null || user_org.plan==""){
                        console.log("no plan")
                        let publishedChapters=0;
                        articles.forEach((article) => {
                            article.chapters.forEach((chapter) => {
                            if(chapter.published==true){
                                publishedChapters++;
                            }
                            });
                        });
                        console.log("publishedChapters", publishedChapters)
                        //Current tiers does not limit number of published chapters. Keep this here commented out for future updates
                        //if(publishedChapters>10){
                        //    resolve(false)
                        //}else{
                            self.showFreeBanner=true;
                            //resolve(true)
                        //}
                        
                        resolve(true)

                    }else{
                        /*
                        console.log("Maker Monthly id", process.env.MAKER_MONTHLY_PLAN_ID)
                        console.log("Maker Yearly id", process.env.MAKER_YEARLY_PLAN_ID)
                        console.log("Team Monthly id", process.env.TEAM_MONTHLY_PLAN_ID)
                        console.log("Team Yearly id", process.env.TEAM_YEARLY_PLAN_ID)  
                        console.log("Company Monthly id", process.env.COMPANY_MONTHLY_PLAN_ID)
                        console.log("Company Yearly id", process.env.COMPANY_YEARLY_PLAN_ID)
                        console.log("has plan: ", user_org.plan)
                        */
                        if(user_org.plan==process.env.MAKER_MONTHLY_PLAN_ID || user_org.plan==process.env.MAKER_YEARLY_PLAN_ID){
                            self.showMakerBanner=true;
                        }else if(user_org.plan==process.env.TEAM_MONTHLY_PLAN_ID || user_org.plan==process.env.TEAM_YEARLY_PLAN_ID){
                            self.showTeamBanner=true;
                        }else if(user_org.plan==process.env.COMPANY_MONTHLY_PLAN_ID || user_org.plan==process.env.COMPANY_YEARLY_PLAN_ID){
                            self.showCompanyBanner=true;
                        }
                        resolve(true)
                    }
                    })
                })
            })
        },
        async checkPlanForQuizzes(quizzes) {
            return new Promise((resolve, reject) => {
                console.log("loadPlanData");
                var self = this;
                GqlQuery.getOrganization( function(err, organization) {
                    organization.then((org)=> {
                    var user_org = org.data.organizations[0];
                    //console.log("user_org", user_org)
                    let counter=0;
                    quizzes.forEach((quiz)=> {
                        if(quiz.active==true){
                            counter++;
                        }
                    })
                    if(user_org.plan==null || user_org.plan==""){
                        console.log("no plan")
                        //let counter=0;
                        /*
                        quizzes.forEach((quiz)=> {
                            if(quiz.active==true){
                                counter++;
                            }
                        })
                        */
                        self.showFreeBanner=true;
                        console.log("counter", counter)
                        if(counter>=1){
                            resolve(false)
                        }else{
                            resolve(true)
                        }
                    }else{
                        if(user_org.plan==process.env.MAKER_MONTHLY_PLAN_ID || user_org.plan==process.env.MAKER_YEARLY_PLAN_ID){
                            self.showMakerBanner=true;
                            console.log("plan is maker")
                            if(counter>=1){
                                resolve(false)
                            }
                        }else if(user_org.plan==process.env.TEAM_MONTHLY_PLAN_ID || user_org.plan==process.env.TEAM_YEARLY_PLAN_ID){
                            self.showTeamBanner=true;
                            console.log("plan is team")
                            if(counter>=10){
                                resolve(false)
                            }
                        }else if(user_org.plan==process.env.COMPANY_MONTHLY_PLAN_ID || user_org.plan==process.env.COMPANY_YEARLY_PLAN_ID){
                            console.log("plan is company")
                            self.showCompanyBanner=true;
                        }
                        resolve(true)
                    }
                    })
                })
            })
        }
          
    }
    
  }  


// WEBPACK FOOTER //
// ./src/mixins/featureGate.js